import { memo as Memo, useCallback, useEffect } from 'react';
import { gsap } from 'gsap';

const PeezzyEyes = Memo(() => {
	useEffect(() => {
		window.addEventListener('mousemove', mouseMove);
		return () => {
			window.removeEventListener('mousemove', mouseMove);
		};
	}, []);

	const mouseMove = useCallback((e) => {
		const size = -5;
		const winWPart = window.innerWidth / 2;
		const winHPart = window.innerHeight / 2;
		const x = ((winWPart - e.clientX) / winWPart) * size;
		const y = ((winHPart - e.clientY) / winHPart) * size;

		gsap.killTweensOf('.peezzyEyes-e');
		gsap.killTweensOf('.peezzyEyes-m');

		gsap.to('.peezzyEyes-e', { duration: 0.5, x, y });
		gsap.to('.peezzyEyes-m', { duration: 0.5, x: x * 0.8, y: y * 0.8 });
	}, []);

	return (
		<svg
			className='peezzyEyes svg-max'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 217.28 150.45'>
			<path
				className={'fill'}
				d='M0,5,52.06,120.7a1.73,1.73,0,0,0,1.61,1L169,119a1.7,1.7,0,0,0,1.55-1L217.28,0S-.47,3.94,0,5Z'
			/>
			<path
				className={'defaultStyle'}
				d='M96.08,109.28c-.46,5-1.45,18.64-2.17,27.27a10.89,10.89,0,0,1-7.77,9.55l-4.72,1.4'
			/>
			<path
				className={'defaultStyle'}
				d='M123.26,110.72c.46,5,1.45,18.65,2.17,27.27a10.88,10.88,0,0,0,7.77,9.55l4.72,1.41'
			/>
			<path
				className={`peezzyEyes-e fillWhite`}
				d='M111,36.7a7.69,7.69,0,0,1,3.45,3,9.12,9.12,0,0,1,1.26,4.73A7.89,7.89,0,0,1,115,47.9a6.27,6.27,0,0,1-2,2.51,4.6,4.6,0,0,1-2.71,1,3.33,3.33,0,0,1-2.09-.56,2.46,2.46,0,0,1-1-1.85,4.93,4.93,0,0,1-1.59,1.85,4.19,4.19,0,0,1-2.34.68,3.9,3.9,0,0,1-2.11-.53,3.8,3.8,0,0,1-1.45-1.57A5.38,5.38,0,0,1,99.26,47c0-.28,0-.49,0-.63a6.4,6.4,0,0,1,.88-3,5.74,5.74,0,0,1,2.12-2.09,6,6,0,0,1,2.93-.79,4.78,4.78,0,0,1,3.35,1.07,3.88,3.88,0,0,1,1.29,3,6,6,0,0,1,0,.84l-.27,2.08a2.24,2.24,0,0,0,0,.46,1.05,1.05,0,0,0,.25.79,1,1,0,0,0,.74.21,1.82,1.82,0,0,0,1.25-.53,3.58,3.58,0,0,0,.93-1.51,6.88,6.88,0,0,0,.32-2.4,7,7,0,0,0-.92-3.51,5.78,5.78,0,0,0-2.59-2.31,9.07,9.07,0,0,0-4.11-.77,9.69,9.69,0,0,0-4.87,1.25,7.82,7.82,0,0,0-3,3.26,9.63,9.63,0,0,0-1,4.57,7,7,0,0,0,2.15,5.37,8.55,8.55,0,0,0,6.05,1.81l-.46,2.22a12.79,12.79,0,0,1-5.57-1.08,7.94,7.94,0,0,1-3.53-3.19,10.33,10.33,0,0,1-1.28-5.08,10.88,10.88,0,0,1,1.5-5.88,10.75,10.75,0,0,1,4.28-4,13.54,13.54,0,0,1,6.11-1.48A12.21,12.21,0,0,1,111,36.7Zm-4.48,6.78a2.41,2.41,0,0,0-1.76-.61,2.69,2.69,0,0,0-1.48.46,3,3,0,0,0-1.06,1.27,4.34,4.34,0,0,0-.37,2,2.57,2.57,0,0,0,.69,1.89,2.26,2.26,0,0,0,1.69.64,2.69,2.69,0,0,0,1.47-.46,3,3,0,0,0,1.1-1.28,4.28,4.28,0,0,0,.4-2A2.48,2.48,0,0,0,106.54,43.48Z'
			/>
			<path
				className={`peezzyEyes-e fillWhite`}
				d='M147.87,36.08a7.61,7.61,0,0,1,3.45,3,9.13,9.13,0,0,1,1.26,4.74,7.88,7.88,0,0,1-.7,3.48,6.36,6.36,0,0,1-2,2.52,4.61,4.61,0,0,1-2.71.94,3.36,3.36,0,0,1-2.1-.56,2.47,2.47,0,0,1-.94-1.84,4.93,4.93,0,0,1-1.59,1.85,4.19,4.19,0,0,1-2.34.67,3.79,3.79,0,0,1-2.11-.53,3.74,3.74,0,0,1-1.45-1.57,5.2,5.2,0,0,1-.55-2.36,6.06,6.06,0,0,1,0-.64,6.29,6.29,0,0,1,.88-3,5.87,5.87,0,0,1,2.11-2.09,6,6,0,0,1,2.94-.79A4.78,4.78,0,0,1,145.4,41a3.88,3.88,0,0,1,1.29,3,8.45,8.45,0,0,1,0,.85l-.28,2.08c0,.23,0,.38,0,.46a1,1,0,0,0,.26.78,1.06,1.06,0,0,0,.74.22,1.94,1.94,0,0,0,1.25-.53,3.61,3.61,0,0,0,.92-1.52,6.84,6.84,0,0,0,.33-2.39,6.91,6.91,0,0,0-.93-3.52,5.82,5.82,0,0,0-2.58-2.31,9.07,9.07,0,0,0-4.11-.76,9.59,9.59,0,0,0-4.87,1.25,7.73,7.73,0,0,0-3,3.26,9.85,9.85,0,0,0-1,4.57,7,7,0,0,0,2.16,5.37,8.58,8.58,0,0,0,6.05,1.81l-.46,2.21a12.91,12.91,0,0,1-5.57-1.07,8,8,0,0,1-3.53-3.2,10.3,10.3,0,0,1-1.28-5.08,10.56,10.56,0,0,1,5.78-9.85,13.42,13.42,0,0,1,6.11-1.49A12.2,12.2,0,0,1,147.87,36.08Zm-4.48,6.78a2.42,2.42,0,0,0-1.76-.62,2.69,2.69,0,0,0-1.48.46A3,3,0,0,0,139.08,44a4.43,4.43,0,0,0-.37,2,2.62,2.62,0,0,0,.7,1.89,2.22,2.22,0,0,0,1.69.64,2.73,2.73,0,0,0,1.47-.45,3.19,3.19,0,0,0,1.1-1.29,4.38,4.38,0,0,0,.4-2A2.47,2.47,0,0,0,143.39,42.86Z'
			/>
			<path
				className={`peezzyEyes-m fillWhite`}
				d='M122.51,58.3a11,11,0,0,1,1.3.61c.42.22.76.38,1,.48a1.68,1.68,0,0,0,.75.15q1.16,0,1.38-1.56l2.43,0A6,6,0,0,1,128,61.27a3.71,3.71,0,0,1-3.84.94,11.45,11.45,0,0,1-1.32-.63,9.35,9.35,0,0,0-1-.48,2.08,2.08,0,0,0-.78-.15c-.77,0-1.24.54-1.4,1.57l-2.41,0a6.14,6.14,0,0,1,1.35-3.33,3.49,3.49,0,0,1,2.59-1.14A3.54,3.54,0,0,1,122.51,58.3Z'
			/>
		</svg>
	);
});

export default PeezzyEyes;
